export const numericInput = (state, prop) => ({
    get() { return state[prop] },
    set(value) {
        state[prop] = parseInt(value)
    }
})
